var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.757 8.818a.75.75 0 0 1 1.061-1.06L12 10.938l3.182-3.182a.75.75 0 1 1 1.06 1.061L13.062 12l3.182 3.182a.75.75 0 1 1-1.061 1.06L12 13.062l-3.182 3.182a.75.75 0 0 1-1.06-1.061L10.938 12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0",
    clipRule: "evenodd"
  })));
};
export default SvgCloseCircle;